export const ProjectData = [
    {
        id:1,
        title:"INVEST Web Applications of Dassault Systemes ",
        about:"Developed the frontend of the Invest web applications that handles end customers. Optimized performance of the web apps to load faster in less bandwidth. Created reusable components for the web apps. Worked on CI/CD to ensure continuous deployment. ",
        tags: ["Vue.js", "Nuxt.js", "Drupal", "JavaScript", "AWS"],
        demo:"",
        github:"",
        image:"https://d2slcw3kip6qmk.cloudfront.net/marketing/blog/2017Q2/project-planning-header@2x.png"
    },
    {
        id:2,
        title:"Cards Application of Dassault Systemes ",
        about:"Maintenance of Exalead and ESB frameworks. ESB(Enterprise service bus) is used to store all the nodes available in Dassault Systemes website using mysql. Exalead is then used for cardification of all the nodes available in ESB database and index them, then expose them using API and use in other frameworks. Exalead is a search engine developed by Dassault Systemes.",
        tags: ["Exalead", "ESB", "SQL", "XML", "WSO2"],
        demo:"",
        github:"",
        image:"https://d2slcw3kip6qmk.cloudfront.net/marketing/blog/2017Q2/project-planning-header@2x.png"
    }
]